module.exports = __webpack_public_path__ + "img/message-text-square-02.2f04ba64.svg";